<template>
  <div class="page_content"><router-view /></div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.page_content {
  flex: 1;
  overflow: auto;
  // position: relative;
  // top: 0;
  // left: 0;
}
</style>
